import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "reasonInput"]

  open(event) {
    const { requestId, declineUrl } = event.currentTarget.dataset
    this.formTarget.action = declineUrl
    this.reasonInputTarget.value = ""
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.reasonInputTarget.focus()
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
